import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from '../App';
import ExperienceDetails from '../components/Details/ExperienceDetails';
import HistoryDetails from '../components/Details/HistoryDetails';
import HariDetails from '../components/Details/HariDetails';
import TechnicalSkillDetails from '../components/Details/TechnicalSkillDetails';
import EducationDetails from '../components/Details/EducationDetails';
import ScrollToTop from '../components/ScrollToTop/ScrollToTop';
import ErrorComponent from '../components/ErrorComponent/ErrorComponent';

const RouteNow = () => {
  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
          <Route path='/' element={<App />} />
          <Route path='/experience'>
            <Route path=':companyName' element={<ExperienceDetails />} />
          </Route>
          <Route path='/history' element={<HistoryDetails />} />
          <Route path='/harisumiran' element={<HariDetails />}>
            <Route path=':project' element={<HariDetails />} />
          </Route>
          <Route path='/technical-skills' element={<TechnicalSkillDetails />} />
          <Route path='/education' element={<EducationDetails />} />
          <Route path='*' element={<ErrorComponent />} />
        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default RouteNow;
